<template>
  <blank-view>
    <div slot="action" style="display: flex; align-items: center; justify-content: space-between">
      <div>
        <a-button v-acl="'page_ops_knowledge_library_create'" type="primary" style="margin-right: 8px" @click="handleAdd">
          <a-icon type="plus" />{{$t('page_ops_knowledge_library_create')}}
        </a-button>
        <a-button v-acl="'page_ops_knowledge_library_import'" style="margin-right: 8px" @click="openImport"> {{$t('page_ops_knowledge_library_import')}} </a-button>
        <a-button v-acl="'page_ops_knowledge_library_delete'" type="danger" :disabled="selectedRowKeys.length === 0" @click="handleDelete">
          {{ $t('delete') }}
        </a-button>
      </div>
      <div>
        <a-select
          show-search
          optionFilterProp="children"
          :value="advanceSearch.deviceTypeId"
          style="width: 200px; margin-right: 4px"
          @change="handleChange"
        >
          <a-select-option v-for="(item, index) in deviceTypes" :key="index" :value="item.key">
            {{ item.value }}
          </a-select-option>
        </a-select>
        <a-input-search
          v-model="advanceSearch.keyValue"
          :placeholder="$t('common_please_input') + $t('page_ops_customer_keyword')"
          :enterButton="$t('search')"
          allowClear
          style="width: 300px"
          @search="searchData"
        />
      </div>
    </div>
    <div style="display: flex; flex-wrap: nowrap; height: 100%">
      <div id="custom-list" class="custom-list">
        <ml-table
          :columns="columns"
          :dataSource="dataSource"
          :rowSelection="{
            selectedRowKeys: selectedRowKeys,
            onChange: onSelectChange
          }"
          size="small"
          rowKey="id"
          :loading="loading"
          :pagination="false"
          :selectRowKey="selectedRow && selectedRow.id"
          :scroll="{ y: scrollY }"
          :customRow="
            (row) => ({
              on: {
                click: () => {
                  clickRow(row)
                }
              }
            })
          "
        >
        </ml-table>
        <a-pagination
          size="small"
          style="position: absolute; bottom: 8px; right: 8px"
          :show-total="(total) => `${showTotal(total)}`"
          :current="filter.current"
          :pageSize="filter.size"
          :total="total"
          showLessItems
          @change="handleTableChange"
        />
      </div>
      <div class="custom-detail">
        <knowledge-detail
          :issueTypes="issueTypes"
          :knowledge="selectedRow"
          class="knowledge-detail"
        ></knowledge-detail>
      </div>
    </div>
    <add-edit
      :issueTypes="issueTypes"
      :visible="addEditVisible"
      :editItem="editItem"
      :isEdit="isEdit"
      @close="(value) => colseAddEdit(value)"
    ></add-edit>
    <import-button
      :visible="importVisible"
      @closeImport="(value) => closeImport(value)"
    ></import-button>
  </blank-view>
</template>

<script>
import KnowledgeDetail from './components/KnowledgeDetail'
import AddEdit from './components/AddEdit.vue'
import { KnowledgeLibraryServiceProxy } from '@/service-proxies/app-v2/knowledge-library.service-proxies'
import { DeviceTypeServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { DictServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import ImportButton from './components/ImportButton.vue'

const dbsp = new DictServiceProxy()
const klsp = new KnowledgeLibraryServiceProxy()
const dtsp = new DeviceTypeServiceProxy()

export default {
  components: {
    KnowledgeDetail,
    AddEdit,
    ImportButton
  },
  data() {
    return {
      total: 0,
      advanceSearch: {
        deviceTypeId: 0,
        keyValue: ''
      },
      filter: {
        // 查询条件
        size: 20,
        current: 1
      },
      columns: [
        {
          title: this.$t('actions'),
          dataIndex: 'action',
          key: 'action',
          width: 100,
          customRender: (_, record) => {
            return (
              <div>
                <a v-acl={'page_ops_knowledge_library_edit'}
                  onClick={(e) => {
                    e.stopPropagation()
                    this.edit(record)
                  }}
                >
                  {this.$t('edit')}
                </a>
                <a-divider type="vertical" />
                <a v-acl={'page_ops_knowledge_library_delete'}
                  style="color: #ff4d4f"
                  onClick={(e) => {
                    e.stopPropagation()
                    this.delete(record)
                  }}
                >
                  {this.$t('delete')}
                </a>
              </div>
            )
          }
        },
        {
          title: '故障码',
          dataIndex: 'issueCode',
          key: 'issueCode',
          ellipsis: true
        },
        {
          title: '设备型号',
          dataIndex: 'deviceTypeName',
          key: 'deviceTypeName',
          ellipsis: true
        },
        {
          title: '故障类型',
          dataIndex: 'issueType',
          key: 'issueType',
          ellipsis: true,
          customRender: (text, record) => {
            return <a-tag color={this.issType(text)}>{this.issTypeName(text)}</a-tag>
          }
        }
      ],
      dataSource: [],
      selectedRow: {}, // 编辑数据
      selectedRowKeys: [], // 选中ids
      addEditVisible: false,
      isEdit: true,
      scrollY: 0,
      editItem: {},
      loading: false,
      deviceTypes: [],
      issueTypes: [],
      importVisible: false
    }
  },
  async created() {
    this.getList()
    this.getTypeList()
    const issueTypes = await dbsp.dictionary('issue-type')
    this.issueTypes = issueTypes.data
  },
  methods: {
    showTotal(total) {
      return this.$t('Total…items').replace('{0}', total)
    },
    handleTableChange(current) {
      this.filter.current = current
      this.getList()
    },
    openImport() {
      // 上传
      this.importVisible = true
    },
    closeImport(value) {
      this.importVisible = false
      if (value) {
        this.getList()
      }
    },
    async getTypeList() {
      const filter = {
        keywords: '',
        query: {
          current: 1,
          size: -1
        }
      }
      const type = await dtsp.pageDeviceType(filter)
      this.deviceTypes = [{ key: 0, value: this.$t('page_ops_customer_all_types') }]
      const list = type.records.map((res) => {
        return { key: res.id, value: res.name }
      })
      this.deviceTypes = this.deviceTypes.concat(list)
    },
    handleChange(value) {
      this.advanceSearch.deviceTypeId = value
      this.filter.current = 1
      this.getList()
    },
    issType(name) {
      let color = 'blue'
      switch (name) {
        case '3':
          color = 'blue'
          break
        case '2':
          color = 'orange'
          break
        case '1':
          color = 'red'
          break
      }
      return color
    },
    issTypeName(value) {
      let name = ''
      const target = this.issueTypes.find((res) => res.dictKey == value)
      if (target) {
        name = target.dictValue
      }
      return name
    },
    async getList() {
      this.loading = true
      const selectRow = this.selectedRow
      this.selectedRow = {}
      const advance = {
        keyValue: this.advanceSearch.keyValue,
        deviceTypeId: this.advanceSearch.deviceTypeId === 0 ? '' : this.advanceSearch.deviceTypeId
      }
      const list = await klsp.getPageKnowledgeLibrary(
        this.filter.current,
        advance,
        this.filter.size
      )
      this.loading = false
      this.dataSource = list.records
      this.total = list.total
      if (list.records && list.records.length) {
        if (JSON.stringify(selectRow) === '{}') {
          this.selectedRow = list.records[0]
          this.selectedRowKeys = [list.records[0].id]
        } else {
          const item = list.records.find((res) => res.id === selectRow.id)
          if (!item) {
            this.selectedRow = list.records[0]
            this.selectedRowKeys = [list.records[0].id]
          } else {
            this.selectedRow = selectRow
            this.selectedRowKeys = [selectRow.id]
          }
        }
      }
      const dev = document.getElementById('custom-list')
      if (dev) {
        const height = dev.clientHeight - 80
        if (height < list.records.length * 33) {
          this.scrollY = height
        } else {
          this.scrollY = 0
        }
      }
    },
    edit(row) {
      klsp.getKnowledgeLibraryDetail('', row.id, row.issueCode).then((res) => {
        this.editItem = res
        this.isEdit = true
        this.addEditVisible = true
      })
    },
    handleAdd() {
      this.editItem = {}
      this.isEdit = false
      this.addEditVisible = true
    },
    colseAddEdit(value) {
      if (value) {
        this.getList()
      }
      this.addEditVisible = false
    },
    async delete(row) {
      this.$confirm({
        title: '删除客户',
        content: '删除客户后该操作不可恢复,是否确认删除?',
        okText: this.$t('delete'),
        okType: 'danger',
        cancelText: this.$t('cancel'),
        icon: () => <a-icon style="color: #ff0000" type="exclamation-circle" />,
        onOk: () => {
          this.readyDelete([row.id])
        }
      })
    },
    async readyDelete(value) {
      await klsp.deleteKnowledgeLibrary(value)
      this.$message.success('删除成功')
      this.getList()
    },
    async handleDelete() {
      this.$confirm({
        title: '删除报警信息',
        content: '删除报警信息后该操作不可恢复,是否确认删除?',
        okText: this.$t('delete'),
        okType: 'danger',
        cancelText: this.$t('cancel'),
        icon: () => <a-icon style="color: #ff0000" type="exclamation-circle" />,
        onOk: () => {
          this.readyDelete(this.selectedRowKeys)
        }
      })
    },
    toggleSearch() {
      console.log(22)
    },
    searchData() {
      this.getList()
    },
    onSelectChange(keys) {
      this.selectedRowKeys = keys
    },
    clickRow(row) {
      this.selectedRow = row
      this.selectedRowKeys = [row.id]
    }
  }
}
</script>

<style lang="less" scoped>
.exception {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: #f0f2f5;
  padding-bottom: 240px;
  .text {
    padding: 24px;
    p {
      font-size: 20px;
    }
  }
}
.custom-list {
  width: 600px;
  position: relative;
}
.custom-detail {
  width: calc(100% - 600px);
  border-left: 1px solid #d7d7d7;
  height: 100%;
  overflow: hidden;
}
</style>
